import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import mapRoomToForm from '../../../models/Room/mappers/mapRoomToForm'
import { IStore } from '../../../reducers'
import { getCustomColors } from '../../../reducers/bookingCalendar/selectors/getCustomColors'
import {
  findRoomForOpenModal,
  getRoomsPositions,
} from '../../../reducers/bookingCalendar/selectors/rooms'
import { getRoomIdFromOpenModal } from '../../../reducers/bookingCalendar/selectors/getModalOpen'
import { getUserProfile } from '../../../reducers/userObject/selectors/settings'
import { IRoomEditorProps } from './CreateRoom'
import { onSubmitUpdate } from './submit'
import validateErrors from './validateErrors'
import validateWarnings from './validateWarnings'
import { IFormValues } from './index'
import { getBookingObjects } from '../../../reducers/booking/selectors'

export default function(formName: string) {
  return reduxForm<IFormValues>({
    enableReinitialize: true,
    form: formName,
    onSubmit: onSubmitUpdate(formName),
    validate: validateErrors,
    warn: validateWarnings,
  })
}

const mapStateToProps = () => {
  const findRoom = findRoomForOpenModal
  const positions = getRoomsPositions
  const getRoom = getRoomIdFromOpenModal

  return (state: IStore, ownProps): IRoomEditorProps => {
    const roomId = getRoom(state)
    const {
      booking,
      iCalendar,
      iCalendarSync,
      airbnb_mapping,
      ...rest
    } = findRoom(roomId ? roomId : ownProps.roomId)(state)
    let bookingRooms: any = getBookingObjects(state)
    bookingRooms = bookingRooms.reduce((acc, booking) => acc.concat(booking.rooms), [])

    let fits = rest.roomSize

    if (booking && bookingRooms) {
      const bookingFits = bookingRooms.find(
        room => String(room.id) === String(rest.bookingRoomId),
      )
      if (bookingFits) {
        fits = bookingFits.fits
      }
    }



    const profile = getUserProfile(state)

    return {
      booking,
      syncFits: Number(fits) !== Number(rest.roomSize) ? fits : false,
      airbnb: airbnb_mapping,
      colors: getCustomColors(state),
      iCalendar,
      iCalendarSync,
      initialValues: mapRoomToForm(
        {
          booking,
          airbnb: airbnb_mapping,
          iCalendar,
          iCalendarSync,
          ...rest,
        } as any,
        profile,
      ),
      positions: positions(state),
      type: 'update',
    }
  }
}

export const withUpdateInitialValues = connect(mapStateToProps())
